import {validateField, clearFields, setFieldOptions, setCheckBoxValue} from './helpers/form'
import {
  SET_VACANCY_CRITERIA_DROPDOWN_OPTIONS,
  VALIDATE_VACANCY_CRITERIA_VOICEACTOR_FIELD,
  CLEAR_VACANCY_CRITERIA_VOICEACTOR_FIELDS,
  SET_VACANCY_CRITERIA_CHECKBOX_VALUE
} from '../../../actions/pages/vacancy-page'
import {
  SET_VOICE_TEST_CRITERIA_DROPDOWN_OPTIONS,
  VALIDATE_VOICE_TEST_CRITERIA_VOICEACTOR_FIELD,
  CLEAR_VOICE_TEST_CRITERIA_VOICEACTOR_FIELDS,
  SET_VOICE_TEST_CRITERIA_CHECKBOX_VALUE
} from '../../../actions/pages/voice-test-page'

export function voiceTestAndVacancyCriteria (
  state = {
    valid: false,
    fields: [/*personal*/
      {
        name: 'SkillLevel',
        value: '',
        errors: [],
        rules: {
          title: 'Rating'
        },
        placeholder: 'Any level',
        options: []
      },
      {
        name: 'NativeLanguage',
        value: '',
        errors: [],
        rules: {
          title: 'Native language'
        },
        placeholder: 'Any language',
        options: []
      },
      {
        name: 'AdditionalLanguage',
        value: '',
        errors: [],
        rules: {
          title: 'Additional language'
        },
        placeholder: 'Any language',
        options: []
      },
      {
        name: 'AgeFrom',
        value: '',
        errors: [],
        type: 'select',
        rules: {
          title: 'Age from'
        },
        placeholder: 'Any age',
        options: []
      },
      {
        name: 'AgeTo',
        value: '',
        errors: [],
        type: 'select',
        rules: {
          title: 'Age to'
        },
        placeholder: 'Any age',
        options: []
      },
      {
        name: 'City',
        value: '',
        errors: [],
        rules: {
          title: 'Preferred  city'
        },
        placeholder: 'Any city',
        options: []
      },
      {
        name: 'CountryofLiving',
        value: '',
        type: 'select',
        errors: [],
        rules: {
          title: 'Country of residence'
        },
        placeholder: 'Any country',
        options: []
      },
      {
        name: 'Region',
        value: '',
        type: 'select',
        errors: [],
        rules: {
          title: 'Region'
        },
        placeholder: 'Any region',
        options: []
      },
      {
        name: 'Ethnicity',
        value: '',
        type: 'select',
        errors: [],
        rules: {
          title: 'Ethnicity'
        },
        placeholder: 'Any ethnicity',
        options: []
      },
      {
        name: 'Identity',
        value: '',
        type: 'select',
        errors: [],
        rules: {
          title: 'Identity'
        },
        placeholder: 'Any identity',
        options: []
      },
      {
          name: 'DoNotUse',
          value: false,
          type: 'checkbox',
          errors: [],
          rules: {
            title: 'Do not use'
          },
          options: []
      },
      {
        name: 'KnownTalent',
        value: false,
        type: 'checkbox',
        errors: [],
        rules: {
          title: 'Known talent'
        }
      },
      {
        name: 'SkillVendorStatus',
        value: '',
        type: 'checkbox',
        errors: [],
        rules: {
          title: 'Inactive talent'
        },
        options: []
      },/*personal end*/
      {
        name: 'VoiceActorLiveActionMaleVoiceGender',
        value: false,
        type: 'checkbox',
        errors: [],
        rules: {
          title: 'Male'
        }
      },
      {
        name: 'VoiceActorLiveActionFemaleVoiceGender',
        value: false,
        type: 'checkbox',
        errors: [],
        rules: {
          title: 'Female'
        }
      },
      {
        name: 'VoiceActorAnimationMaleVoiceGender',
        value: false,
        type: 'checkbox',
        errors: [],
        rules: {
          title: 'Male'
        }
      },
      {
        name: 'VoiceActorAnimationFemaleVoiceGender',
        value: false,
        type: 'checkbox',
        errors: [],
        rules: {
          title: 'Female'
        }
      },
      {
        name: 'VoiceActorVoiceAge',
        value: '',
        type: 'select',
        errors: [],
        rules: {
          title: 'Voice age'
        },
        placeholder: 'Any age',
        options: []
      },
      {
        name: 'VoiceActorVoiceType',
        value: '',
        type: 'select',
        errors: [],
        rules: {
          title: 'Voice type'
        },
        placeholder: 'Any type',
        options: []
      },
      {
        name: 'VoiceActorLanguageAccent',
        value: '',
        type: 'select',
        errors: [],
        rules: {
          title: 'Language accent'
        },
        placeholder: 'Any accent',
        options: []
      },
      {
        name: 'VoiceActorTheatricalExperience',
        value: false,
        type: 'checkbox',
        errors: [],
        rules: {
          title: 'Theatrical'
        }
      },
      {
        name: 'VoiceActorTVExperience',
        value: false,
        type: 'checkbox',
        errors: [],
        rules: {
          title: 'TV'
        }
      },
      {
        name: 'VoiceActorGamesExperience',
        value: false,
        type: 'checkbox',
        errors: [],
        rules: {
          title: 'Video Games'
        }
      },
      {
        name: 'VoiceActorPromoOrCommercialsExperience',
        value: false,
        type: 'checkbox',
        errors: [],
        rules: {
          title: 'Promo/Commercials'
        }
      },
      {
        name: 'VoiceActorLiveActionExperience',
        value: false,
        type: 'checkbox',
        errors: [],
        rules: {
          title: 'L/A'
        }
      },
      {
        name: 'VoiceActorAnimationExperience',
        value: false,
        type: 'checkbox',
        errors: [],
        rules: {
          title: 'Animation'
        }
      },
      {
        name: 'VoiceActorDubbingExperience',
        value: false,
        type: 'checkbox',
        errors: [],
        rules: {
          title: 'Dubbing'
        }
      },
      {
        name: 'VoiceActorAudiobooksExperience',
        value: false,
        type: 'checkbox',
        errors: [],
        rules: {
          title: 'Audiobooks'
        }
      },
      {
        name: 'VoiceActorVoiceOverExperience',
        value: false,
        type: 'checkbox',
        errors: [],
        rules: {
          title: 'V/O'
        }
      },
      {
        name: 'VoiceActorRadioExperience',
        value: false,
        type: 'checkbox',
        errors: [],
        rules: {
          title: 'Radio'
        }
      },
      {
        name: 'VoiceActorTheatreActorExperience',
        value: false,
        type: 'checkbox',
        errors: [],
        rules: {
          title: 'Theatre Actor'
        }
      },
      {
        name: 'VoiceActorMovieActorExperience',
        value: false,
        type: 'checkbox',
        errors: [],
        rules: {
          title: 'Movie Actor'
        }
      },
      {
        name: 'VoiceActorAudioDescriptionExperience',
        value: false,
        type: 'checkbox',
        errors: [],
        rules: {
          title: 'Audio description'
        }
      },
      {
        name: 'VoiceActorStudios',
        value: '',
        type: 'select',
        errors: [],
        rules: {
          title: 'Studios',
          url: 'studios',
          profileType: 'VoiceActor'
        },
        placeholder: 'Any studio',
        options:''
      },
      {
        name: 'VoiceActorClients',
        value: '',
        type: 'text',
        errors: [],
        rules: {
          title: 'Clients',
          url: 'clients',
          profileType: 'VoiceActor'
        },
        placeholder: 'Any client'
      },
      {
        name: 'VoiceActorSchools',
        value: '',
        type: 'text',
        errors: [],
        rules: {
          title: 'Schools',
          url: 'schools',
          profileType: 'VoiceActor'
        },
        placeholder: 'Any school'
      },
      {
        name: 'VoiceActorUnion',
        value: '',
        type: 'select',
        errors: [],
        rules: {
          title: 'Union'
        },
        placeholder: 'Any union',
        options: []
      },
      {
        name: 'VoiceActorRemoteRecordingCapability',
        value: '',
        type: 'select',
        errors: [],
        rules: {
          title: 'Remote recording'
        },
        placeholder: 'Any status',
        options: []
      },
      {
        name: 'SkillType',
        value: '',
        errors: [],
        rules: {
          title: 'Additional speciality'
        },
        placeholder: 'Any speciality',
        options: []
      },
      {
        name: 'Production',
        value: '',
        type: 'text',
        errors: [],
        rules: {
          title: 'Booked in production',
          url: 'productions'
        },
        placeholder: 'Any produb title'
      },
      {
        name: 'Vacancy',
        value: '',
        type: 'text',
        errors: [],
        rules: {
          title: 'Booked in offer',
          url: 'vacancies'
        },
        placeholder: 'Any produb title'
      },
      {
        name: 'ExternalExperience',
        value: '',
        type: 'text',
        errors: [],
        rules: {
          title: 'Top 5',
          url: 'externalProductionExperiences'
        },
        placeholder: 'Any TMDb title'
      },
      {
        name: 'BookerTheatricalExperience',
        value: false,
        type: 'checkbox',
        errors: [],
        rules: {
          title: 'Theatrical'
        }
      },
      {
        name: 'BookerTVExperience',
        value: false,
        type: 'checkbox',
        errors: [],
        rules: {
          title: 'TV'
        }
      },
      {
        name: 'BookerInteractiveExperience',
        value: false,
        type: 'checkbox',
        errors: [],
        rules: {
          title: 'Interactive'
        }
      },
      {
        name: 'BookerStudios',
        value: '',
        type: 'text',
        errors: [],
        rules: {
          title: 'Studios',
          url: 'studios',
          profileType: 'Booker'
        },
        placeholder: 'Any studio'
      },
      {
        name: 'SingerMaleVoiceGender',
        value: false,
        type: 'checkbox',
        errors: [],
        rules: {
          title: 'Male'
        }
      },
      {
        name: 'SingerFemaleVoiceGender',
        value: false,
        type: 'checkbox',
        errors: [],
        rules: {
          title: 'Female'
        }
      },
      {
        name: 'SingerVoiceAge',
        value: '',
        type: 'select',
        errors: [],
        rules: {
          title: 'Voice age'
        },
        placeholder: 'Any age',
        options: []
      },
      {
        name: 'SingerVocalRange',
        value: '',
        type: 'select',
        errors: [],
        rules: {
          title: 'Vocal range'
        },
        placeholder: 'Any range',
        options: []
      },
      {
        name: 'SingerMusicNotesReadingLevel',
        value: '',
        type: 'select',
        errors: [],
        rules: {
          title: 'Reading music notes'
        },
        placeholder: 'Any level',
        options: []
      },
      {
        name: 'SingerDubbingExperience',
        value: false,
        type: 'checkbox',
        errors: [],
        rules: {
          title: 'Dubbing'
        }
      },
      {
        name: 'SingerStageExperience',
        value: false,
        type: 'checkbox',
        errors: [],
        rules: {
          title: 'Stage'
        }
      },
      {
        name: 'SingerTheatreExperience',
        value: false,
        type: 'checkbox',
        errors: [],
        rules: {
          title: 'Theatre'
        }
      },
      {
        name: 'SingerTalentShowExperience',
        value: false,
        type: 'checkbox',
        errors: [],
        rules: {
          title: 'Talent show'
        }
      },
      {
        name: 'SingerStudios',
        value: '',
        type: 'text',
        errors: [],
        rules: {
          title: 'Studios',
          url: 'studios',
          profileType: 'Singer'
        },
        placeholder: 'Any studio'
      },
      {
        name: 'SingerClients',
        value: '',
        type: 'text',
        errors: [],
        rules: {
          title: 'Clients',
          url: 'clients',
          profileType: 'Singer'
        },
        placeholder: 'Any client'
      },
      {
        name: 'SingerSchools',
        value: '',
        type: 'text',
        errors: [],
        rules: {
          title: 'Schools',
          url: 'schools',
          profileType: 'Singer'
        },
        placeholder: 'Any school'
      },
      {
        name: 'SingerUnion',
        type: 'select',
        value: '',
        errors: [],
        rules: {
          title: 'Union'
        },
        placeholder: 'Any union',
        options: []
      },
      {
        name: 'SingerRemoteRecordingCapability',
        value: '',
        type: 'select',
        errors: [],
        rules: {
          title: 'Remote recording'
        },
        placeholder: 'Any status',
        options: []
      },
      {
        name: 'DirectorTheatricalExperience',
        value: false,
        type: 'checkbox',
        errors: [],
        rules: {
          title: 'Theatrical'
        }
      },
      {
        name: 'DirectorTVExperience',
        value: false,
        type: 'checkbox',
        errors: [],
        rules: {
          title: 'TV'
        }
      },
      {
        name: 'DirectorGamesExperience',
        value: false,
        type: 'checkbox',
        errors: [],
        rules: {
          title: 'Video Games'
        }
      },
      {
        name: 'DirectorPromoOrCommercialsExperience',
        value: false,
        type: 'checkbox',
        errors: [],
        rules: {
          title: 'Promo/Commercials'
        }
      },
      {
        name: 'DirectorLiveActionExperience',
        value: false,
        type: 'checkbox',
        errors: [],
        rules: {
          title: 'L/A'
        }
      },
      {
        name: 'DirectorAnimationExperience',
        value: false,
        type: 'checkbox',
        errors: [],
        rules: {
          title: 'Animation'
        }
      },
      {
        name: 'DirectorDubbingDirectorExperience',
        value: false,
        type: 'checkbox',
        errors: [],
        rules: {
          title: 'Dubbing Director'
        }
      },
      {
        name: 'DirectorVoiceOverDirectorExperience',
        value: false,
        type: 'checkbox',
        errors: [],
        rules: {
          title: 'V/O Director'
        }
      },
      {
        name: 'DirectorSongDirectorExperience',
        value: false,
        type: 'checkbox',
        errors: [],
        rules: {
          title: 'Song Director'
        }
      },
      {
        name: 'DirectorDubbingActorExperience',
        value: false,
        type: 'checkbox',
        errors: [],
        rules: {
          title: 'Dubbing Actor'
        }
      },
      {
        name: 'DirectorStageDirectorExperience',
        value: false,
        type: 'checkbox',
        errors: [],
        rules: {
          title: 'Stage Director'
        }
      },
      {
        name: 'DirectorMovieDirectorExperience',
        value: false,
        type: 'checkbox',
        errors: [],
        rules: {
          title: 'On Camera Director'
        }
      },
      {
        name: 'DirectorAudioDescriptionExperience',
        value: false,
        type: 'checkbox',
        errors: [],
        rules: {
          title: 'Audio description'
        }
      },
      {
        name: 'DirectorStudios',
        value: '',
        type: 'text',
        errors: [],
        rules: {
          title: 'Studios',
          url: 'studios',
          profileType: 'Director'
        },
        placeholder: 'Any studio'
      },
      {
        name: 'DirectorClients',
        value: '',
        type: 'text',
        errors: [],
        rules: {
          title: 'Clients',
          url: 'clients',
          profileType: 'Director'
        },
        placeholder: 'Any client'
      },
      {
        name: 'DirectorSchools',
        value: '',
        type: 'text',
        errors: [],
        rules: {
          title: 'Schools',
          url: 'schools',
          profileType: 'Director'
        },
        placeholder: 'Any school'
      },
      {
        name: 'DirectorRemoteRecordingCapability',
        value: '',
        type: 'select',
        errors: [],
        rules: {
          title: 'Remote recording'
        },
        placeholder: 'Any status',
        options: []
      },
      {
        name: 'DirectorAppAccessRevoked',
        value: false,
        type: 'select',
        errors: [],
        rules: {
          title: 'Director app access',
        },
        placeholder: 'Any status',
      },
      {
        name: 'LyricistMusicalExperience',
        value: false,
        type: 'checkbox',
        errors: [],
        rules: {
          title: 'Musical'
        }
      },
      {
        name: 'LyricistTheatreExperience',
        value: false,
        type: 'checkbox',
        errors: [],
        rules: {
          title: 'Theatre'
        }
      },
      {
        name: 'LyricistPromoOrCommercialsExperience',
        value: false,
        type: 'checkbox',
        errors: [],
        rules: {
          title: 'Promo/Commercials'
        }
      },
      {
        name: 'LyricistExperience',
        value: false,
        type: 'checkbox',
        errors: [],
        rules: {
          title: 'Lyricist'
        }
      },
      {
        name: 'LyricistDubbingExperience',
        value: false,
        type: 'checkbox',
        errors: [],
        rules: {
          title: 'Dubbing'
        }
      },
      {
        name: 'LyricistMusicianExperience',
        value: false,
        type: 'checkbox',
        errors: [],
        rules: {
          title: 'Musician'
        }
      },
      {
        name: 'LyricistNumberOfSongsWritten',
        value: '',
        type: 'select',
        errors: [],
        rules: {
          title: 'Number of songs written'
        },
        placeholder: 'Any number',
        options: []
      },
      {
        name: 'LyricistUniversityDegree',
        value: '',
        type: 'select',
        errors: [],
        rules: {
          title: 'University degree'
        },
        placeholder: 'Any degree',
        options: []
      },
      {
        name: 'LyricistStudios',
        value: '',
        type: 'text',
        errors: [],
        rules: {
          title: 'Studios',
          url: 'studios',
          profileType: 'Lyricist'
        },
        placeholder: 'Any studio'
      },
      {
        name: 'LyricistClients',
        value: '',
        type: 'text',
        errors: [],
        rules: {
          title: 'Clients',
          url: 'clients',
          profileType: 'Lyricist'
        },
        placeholder: 'Any client'
      },
      {
        name: 'LyricistRemoteRecordingCapability',
        value: '',
        type: 'select',
        errors: [],
        rules: {
          title: 'Remote recording'
        },
        placeholder: 'Any status',
        options: []
      },
      {
        name: 'TranslatorTheatricalExperience',
        value: false,
        type: 'checkbox',
        errors: [],
        rules: {
          title: 'Theatrical'
        }
      },
      {
        name: 'TranslatorTVExperience',
        value: false,
        type: 'checkbox',
        errors: [],
        rules: {
          title: 'TV'
        }
      },
      {
        name: 'TranslatorGamesExperience',
        value: false,
        type: 'checkbox',
        errors: [],
        rules: {
          title: 'Video Games'
        }
      },
      {
        name: 'TranslatorPromoOrCommercialsExperience',
        value: false,
        type: 'checkbox',
        errors: [],
        rules: {
          title: 'Promo/Commercials'
        }
      },
      {
        name: 'TranslatorLiveActionExperience',
        value: false,
        type: 'checkbox',
        errors: [],
        rules: {
          title: 'L/A'
        }
      },
      {
        name: 'TranslatorAnimationExperience',
        value: false,
        type: 'checkbox',
        errors: [],
        rules: {
          title: 'Animation'
        }
      },
      {
        name: 'TranslatorSubtitlesExperience',
        value: false,
        type: 'checkbox',
        errors: [],
        rules: {
          title: 'Subtitles'
        }
      },
      {
        name: 'TranslatorDubbingExperience',
        value: false,
        type: 'checkbox',
        errors: [],
        rules: {
          title: 'Dubbing'
        }
      },
      {
        name: 'TranslatorVoiceOverExperience',
        value: false,
        type: 'checkbox',
        errors: [],
        rules: {
          title: 'V/O'
        }
      },
      {
        name: 'TranslatorGamingExperience',
        value: false,
        type: 'checkbox',
        errors: [],
        rules: {
          title: 'Video Games'
        }
      },
      {
        name: 'TranslatorAudioDescriptionExperience',
        value: false,
        type: 'checkbox',
        errors: [],
        rules: {
          title: 'Audio description'
        }
      },
      {
        name: 'TranslatorHOHSDHCCExperience',
        value: false,
        type: 'checkbox',
        errors: [],
        rules: {
          title: 'Access service subtitling'
        }
      },
      {
        name: 'TranslatorNumberOfTranslations',
        value: '',
        type: 'select',
        errors: [],
        rules: {
          title: 'Number of translations'
        },
        placeholder: 'Any number',
        options: []
      },
      {
        name: 'TranslatorUniversityDegree',
        value: '',
        type: 'select',
        errors: [],
        rules: {
          title: 'University degree'
        },
        placeholder: 'Any degree',
        options: []
      },
      {
        name: 'TranslatorStudios',
        value: '',
        type: 'text',
        errors: [],
        rules: {
          title: 'Studios',
          url: 'studios',
          profileType: 'Translator'
        },
        placeholder: 'Any studio'
      },
      {
        name: 'TranslatorClients',
        value: '',
        type: 'text',
        errors: [],
        rules: {
          title: 'Clients',
          url: 'clients',
          profileType: 'Translator'
        },
        placeholder: 'Any client'
      },
      {
        name: 'EditorDubbingExperience',
        value: false,
        type: 'checkbox',
        errors: [],
        rules: {
          title: 'Dubbing'
        }
      },
      {
        name: 'EditorVoiceOverExperience',
        value: false,
        type: 'checkbox',
        errors: [],
        rules: {
          title: 'V/O'
        }
      },
      {
        name: 'EditorSongsExperience',
        value: false,
        type: 'checkbox',
        errors: [],
        rules: {
          title: 'Songs'
        }
      },
      {
        name: 'EditorProToolsExperience',
        value: false,
        type: 'checkbox',
        errors: [],
        rules: {
          title: 'Pro Tools'
        }
      },
      {
        name: 'EditorDolby51Experience',
        value: false,
        type: 'checkbox',
        errors: [],
        rules: {
          title: 'Dolby 5.1'
        }
      },
      {
        name: 'EditorAtmosExperience',
        value: false,
        type: 'checkbox',
        errors: [],
        rules: {
          title: 'Atmos'
        }
      },
      {
        name: 'EditorFoleyExperience',
        value: false,
        type: 'checkbox',
        errors: [],
        rules: {
          title: 'Foley'
        }
      },
      {
        name: 'EditorRecordingEditingExperience',
        value: false,
        type: 'checkbox',
        errors: [],
        rules: {
          title: 'Recording Editing'
        }
      },
      {
        name: 'EditorDialogueEditingExperience',
        value: false,
        type: 'checkbox',
        errors: [],
        rules: {
          title: 'Dialogue Editing'
        }
      },
      {
        name: 'EditorMusicAndEffectsExperience',
        value: false,
        type: 'checkbox',
        errors: [],
        rules: {
          title: 'M&E'
        }
      },
      {
        name: 'EditorMixEditingExperience',
        value: false,
        type: 'checkbox',
        errors: [],
        rules: {
          title: 'Mix Editing'
        }
      },
      {
        name: 'EditorPreparingTakesExperience',
        value: false,
        type: 'checkbox',
        errors: [],
        rules: {
          title: 'Preparing Takes'
        }
      },
      {
        name: 'EditorAudioDescriptionExperience',
        value: false,
        type: 'checkbox',
        errors: [],
        rules: {
          title: 'Audio description'
        }
      },
      {
        name: 'EditorStudios',
        value: '',
        type: 'text',
        errors: [],
        rules: {
          title: 'Studios',
          url: 'studios',
          profileType: 'Editor'
        },
        placeholder: 'Any studio'
      },
      {
        name: 'EditorClients',
        value: '',
        type: 'text',
        errors: [],
        rules: {
          title: 'Clients',
          url: 'clients',
          profileType: 'Editor'
        },
        placeholder: 'Any client'
      },
      {
        name: 'EditorSchools',
        value: '',
        type: 'text',
        errors: [],
        rules: {
          title: 'Schools',
          url: 'schools',
          profileType: 'Editor'
        },
        placeholder: 'Any school'
      },
      {
        name: 'EditorRemoteRecordingCapability',
        value: '',
        type: 'select',
        errors: [],
        rules: {
          title: 'Remote recording capability'
        },
        placeholder: 'Any status',
        options: []
      },
      {
        name: 'AdaptorTheatricalExperience',
        value: false,
        type: 'checkbox',
        errors: [],
        rules: {
          title: 'Theatrical'
        }
      },
      {
        name: 'AdaptorTVExperience',
        value: false,
        type: 'checkbox',
        errors: [],
        rules: {
          title: 'TV'
        }
      },
      {
        name: 'AdaptorGamesExperience',
        value: false,
        type: 'checkbox',
        errors: [],
        rules: {
          title: 'Video games'
        }
      },
      {
        name: 'AdaptorPromoOrCommercialsExperience',
        value: false,
        type: 'checkbox',
        errors: [],
        rules: {
          title: 'Promos/Commercials'
        }
      },
      {
        name: 'AdaptorLiveActionExperience',
        value: false,
        type: 'checkbox',
        errors: [],
        rules: {
          title: 'L/A'
        }
      },
      {
        name: 'AdaptorAnimationExperience',
        value: false,
        type: 'checkbox',
        errors: [],
        rules: {
          title: 'Animation'
        }
      },
      {
        name: 'AdaptorAdaptorExperience',
        value: false,
        type: 'checkbox',
        errors: [],
        rules: {
          title: 'Adaptor'
        }
      },
      {
        name: 'AdaptorDubbingDirectorExperience',
        value: false,
        type: 'checkbox',
        errors: [],
        rules: {
          title: 'Dubbing Director'
        }
      },
      {
        name: 'AdaptorTranslatorExperience',
        value: false,
        type: 'checkbox',
        errors: [],
        rules: {
          title: 'Translator'
        }
      },
      {
        name: 'AdaptorVoiceActorExperience',
        value: false,
        type: 'checkbox',
        errors: [],
        rules: {
          title: 'Voice Actor'
        }
      },
      {
        name: 'AdaptorAudioDescriptionExperience',
        value: false,
        type: 'checkbox',
        errors: [],
        rules: {
          title: 'Audio description'
        }
      },
      {
        name: 'AdaptorNumberOfAdaptionsRange',
        value: '',
        type: 'select',
        errors: [],
        rules: {
          title: 'Number of adaptations'
        },
        placeholder: 'Any number',
        options: []
      },
      {
        name: 'AdaptorUniversityDegree',
        value: '',
        type: 'select',
        errors: [],
        rules: {
          title: 'University degree'
        },
        placeholder: 'Any degree',
        options: []
      },
      {
        name: 'AdaptorStudios',
        value: '',
        type: 'text',
        errors: [],
        rules: {
          title: 'Studios',
          url: 'studios',
          profileType: 'Adaptor'
        },
        placeholder: 'Any studio'
      },
      {
        name: 'AdaptorClients',
        value: '',
        type: 'text',
        errors: [],
        rules: {
          title: 'Clients',
          url: 'clients',
          profileType: 'Adaptor'
        },
        placeholder: 'Any client'
      },
      {
        name: 'SoundEngineerDubbingExperience',
        value: false,
        type: 'checkbox',
        errors: [],
        rules: {
          title: 'Dubbing'
        }
      },
      {
        name: 'SoundEngineerVoiceOverExperience',
        value: false,
        type: 'checkbox',
        errors: [],
        rules: {
          title: 'V/O'
        }
      },
      {
        name: 'SoundEngineerSongsExperience',
        value: false,
        type: 'checkbox',
        errors: [],
        rules: {
          title: 'Songs'
        }
      },
      {
        name: 'SoundEngineerProToolsExperience',
        value: false,
        type: 'checkbox',
        errors: [],
        rules: {
          title: 'Pro Tools'
        }
      },
      {
        name: 'SoundEngineerDolby51Experience',
        value: false,
        type: 'checkbox',
        errors: [],
        rules: {
          title: 'Dolby 5.1'
        }
      },
      {
        name: 'SoundEngineerAtmosExperience',
        value: false,
        type: 'checkbox',
        errors: [],
        rules: {
          title: 'Atmos'
        }
      },
      {
        name: 'SoundEngineerFoleyExperience',
        value: false,
        type: 'checkbox',
        errors: [],
        rules: {
          title: 'Foley'
        }
      },
      {
        name: 'SoundEngineerDialogueRecordingExperience',
        value: false,
        type: 'checkbox',
        errors: [],
        rules: {
          title: 'Dialogue Recording'
        }
      },
      {
        name: 'SoundEngineerSongRecordingExperience',
        value: false,
        type: 'checkbox',
        errors: [],
        rules: {
          title: 'Song Recording'
        }
      },
      {
        name: 'SoundEngineerDialogueMixingExperience',
        value: false,
        type: 'checkbox',
        errors: [],
        rules: {
          title: 'Dialogue Mixing'
        }
      },
      {
        name: 'SoundEngineerSongMixingExperience',
        value: false,
        type: 'checkbox',
        errors: [],
        rules: {
          title: 'Song Mixing'
        }
      },
      {
        name: 'SoundEngineerAudioDescriptionMixingExperience',
        value: false,
        type: 'checkbox',
        errors: [],
        rules: {
          title: 'Audio description mixing'
        }
      },
      {
        name: 'SoundEngineerStudios',
        value: '',
        type: 'text',
        errors: [],
        rules: {
          title: 'Studios',
          url: 'studios',
          profileType: 'SoundEngineer'
        },
        placeholder: 'Any studio'
      },
      {
        name: 'SoundEngineerClients',
        value: '',
        type: 'text',
        errors: [],
        rules: {
          title: 'Clients',
          url: 'clients',
          profileType: 'SoundEngineer'
        },
        placeholder: 'Any client'
      },
      {
        name: 'SoundEngineerSchools',
        value: '',
        type: 'text',
        errors: [],
        rules: {
          title: 'Schools',
          url: 'schools',
          profileType: 'SoundEngineer'
        },
        placeholder: 'Any school'
      },
      {
        name: 'SoundEngineerRemoteRecordingCapability',
        value: '',
        errors: [],
        rules: {
          title: 'Remote recording'
        },
        placeholder: 'Any status',
        options: []
      },
      {
        name: 'SingerGenderNeutralVoice',
        value: false,
        type: 'checkbox',
        errors: [],
        rules: {
          title: 'Androgynous'
        }
      },
      {
        name: 'VoiceActorGenderNeutralVoice',
        value: false,
        type: 'checkbox',
        errors: [],
        rules: {
          title: 'Androgynous'
        }
      },
      {
        name: 'SkillTypeFixed',
        value: '',
        errors: [],
        rules: {
          title: 'Speciality'
        },
        placeholder: '',
        options: [],
        disabled: true
      },
      {
        name: 'AdaptorDoNotUse',
        value: false,
        type: 'checkbox',
        errors: [],
        rules: {
          title: 'Do not use'
        }
      },
      {
        name: 'BookerDoNotUse',
        value: false,
        type: 'checkbox',
        errors: [],
        rules: {
          title: 'Do not use'
        }
      },
      {
        name: 'DirectorDoNotUse',
        value: false,
        type: 'checkbox',
        errors: [],
        rules: {
          title: 'Do not use'
        }
      },
      {
        name: 'EditorDoNotUse',
        value: false,
        type: 'checkbox',
        errors: [],
        rules: {
          title: 'Do not use'
        }
      },
      {
        name: 'LyricistDoNotUse',
        value: false,
        type: 'checkbox',
        errors: [],
        rules: {
          title: 'Do not use'
        }
      },
      {
        name: 'SingerDoNotUse',
        value: false,
        type: 'checkbox',
        errors: [],
        rules: {
          title: 'Do not use'
        }
      },
      {
        name: 'SoundEngineerDoNotUse',
        value: false,
        type: 'checkbox',
        errors: [],
        rules: {
          title: 'Do not use'
        }
      },
      {
        name: 'TranslatorDoNotUse',
        value: false,
        type: 'checkbox',
        errors: [],
        rules: {
          title: 'Do not use'
        }
      },
      {
        name: 'VoiceActorDoNotUse',
        value: false,
        type: 'checkbox',
        errors: [],
        rules: {
          title: 'Do not use'
        }
      }

    ]
  },

  action
) {
  switch (action.type) {
    case SET_VACANCY_CRITERIA_DROPDOWN_OPTIONS: {
      var newState = setFieldOptions(state, 'SkillLevel', action.skillLevels);
      newState = setFieldOptions(newState, 'City', action.cities);
      newState = setFieldOptions(newState, 'NativeLanguage', action.nativeLanguages);
      newState = setFieldOptions(newState, 'AdditionalLanguage', action.languages);
      newState = setFieldOptions(newState, 'AgeFrom', action.ageFromList);
      newState = setFieldOptions(newState, 'AgeTo', action.ageToList);
      newState = setFieldOptions(newState, 'CountryofLiving', action.country);
      newState = setFieldOptions(newState, 'Region', action.region);
      newState = setFieldOptions(newState, 'Ethnicity', action.ethnicity);
      newState = setFieldOptions(newState, 'Identity', action.identity);
      newState = setFieldOptions(newState, 'VoiceActorVoiceAge', action.voiceAgeRangeList);
      newState = setFieldOptions(newState, 'VoiceActorVoiceType', action.voiceTypeList);
      newState = setFieldOptions(newState, 'VoiceActorRemoteRecordingCapability', action.remoteRecordingListVoiceActor);
      newState = setFieldOptions(newState, 'VoiceActorStudios', action.voiceActorStudio);
      newState = setFieldOptions(newState, 'VoiceActorSchools', action.voiceActorSchool);
      newState = setFieldOptions(newState, 'VoiceActorLanguageAccent', action.languageAccentList);
      newState = setFieldOptions(newState, 'VoiceActorUnion', action.unionListVoiceActor);
      newState = setFieldOptions(newState, 'SkillType', action.skillTypes);
      newState = setFieldOptions(newState, 'Production', action.productionCast);
      newState = setFieldOptions(newState, 'Vacancy', action.vacancyCast);
      newState = setFieldOptions(newState, 'ExternalExperience', action.externalExperienceCast);
      newState = setFieldOptions(newState, 'BookerStudios', action.bookerStudio);
      newState = setFieldOptions(newState, 'SingerVoiceAge', action.voiceAgeRangeListSinger);
      newState = setFieldOptions(newState, 'SingerVocalRange', action.vocalRangeListSinger);
      newState = setFieldOptions(newState, 'SingerMusicNotesReadingLevel', action.readingMusicNoteListSinger);
      newState = setFieldOptions(newState, 'SingerStudios', action.singerStudio);
      newState = setFieldOptions(newState, 'SingerClient', action.singerClients);
      newState = setFieldOptions(newState, 'SingerSchools', action.singerSchool);
      newState = setFieldOptions(newState, 'SingerRemoteRecordingCapability', action.remoteRecordingListSinger);
      newState = setFieldOptions(newState, 'SingerUnion', action.unionListSinger);
      newState = setFieldOptions(newState, 'DirectorStudios', action.directorStudio);
      newState = setFieldOptions(newState, 'DirectorClient', action.directorClient);
      newState = setFieldOptions(newState, 'DirectorSchools', action.directorSchool);
      newState = setFieldOptions(newState, 'DirectorRemoteRecordingCapability', action.remoteRecordingDirector);
      newState = setFieldOptions(newState, 'DirectorAppAccessRevoked', action.directorAppAccess);
      newState = setFieldOptions(newState, 'LyricistNumberOfSongsWritten', action.numberOfSongsWrittenRangeListLyricist);
      newState = setFieldOptions(newState, 'LyricistUniversityDegree', action.universityDegreeListLyricist);
      newState = setFieldOptions(newState, 'LyricistStudios', action.lyricistStudio);
      newState = setFieldOptions(newState, 'LyricistClients', action.lyricistClient);
      newState = setFieldOptions(newState, 'LyricistRemoteRecordingCapability', action.remoteRecordingListLyricist);
      newState = setFieldOptions(newState, 'TranslatorNumberOfTranslations', action.numberOfTranslationsRangeListTranslator);
      newState = setFieldOptions(newState, 'TranslatorUniversityDegree', action.universityDegreeListTranslator);
      newState = setFieldOptions(newState, 'TranslatorStudios', action.translatorStudio);
      newState = setFieldOptions(newState, 'TranslatorClients', action.translatorClient);
      newState = setFieldOptions(newState, 'EditorStudios', action.editorStudio);
      newState = setFieldOptions(newState, 'EditorClients', action.editorClient);
      newState = setFieldOptions(newState, 'EditorSchools', action.editorSchool);
      newState = setFieldOptions(newState, 'EditorRemoteRecordingCapability', action.remoteRecordingEditor);
      newState = setFieldOptions(newState, 'AdaptorNumberOfAdaptionsRange', action.numberOfAdaptionsRangeListAdaptor);
      newState = setFieldOptions(newState, 'AdaptorUniversityDegree', action.universityDegreeListAdaptor);
      newState = setFieldOptions(newState, 'AdaptorStudios', action.adaptorStudio);
      newState = setFieldOptions(newState, 'AdaptorClients', action.adaptorClient);
      newState = setFieldOptions(newState, 'SoundEngineerStudios', action.soundEngineerStudio);
      newState = setFieldOptions(newState, 'SoundEngineerClients', action.soundEngineerClient);
      newState = setFieldOptions(newState, 'SoundEngineerSchools', action.soundEngineerSchool);
      newState = setFieldOptions(newState, 'SoundEngineerRemoteRecordingCapability', action.remoteRecordingListSoundEngineer);






      return setFieldOptions(newState, 'AgeTo', action.ageToList);
    }

    case SET_VACANCY_CRITERIA_CHECKBOX_VALUE: {
      var newState = setCheckBoxValue(state, 'KnownTalent', action.knownTalent);
      newState = setCheckBoxValue(newState, 'SkillVendorStatus', action.skillVendorStatus);
      newState = setCheckBoxValue(newState, 'VoiceActorLiveActionMaleVoiceGender', action.liveActionVoiceGenderMale);
      newState = setCheckBoxValue(newState, 'VoiceActorLiveActionFemaleVoiceGender', action.liveActionVoiceGenderFemale);
      newState = setCheckBoxValue(newState, 'VoiceActorTheatricalExperience', action.voiceActorTheatricalExperience);
      newState = setCheckBoxValue(newState, 'VoiceActorTVExperience', action.voiceActorTVExperience);
      newState = setCheckBoxValue(newState, 'VoiceActorGamesExperience', action.voiceActorVideoGamesExperience);
      newState = setCheckBoxValue(newState, 'VoiceActorPromoOrCommercialsExperience', action.voiceActorPromoOrCommercialsExperience);
      newState = setCheckBoxValue(newState, 'VoiceActorAnimationMaleVoiceGender', action.voiceActorAnimationMaleVoiceGender);
      newState = setCheckBoxValue(newState, 'VoiceActorAnimationFemaleVoiceGender', action.voiceActorAnimationFemaleVoiceGender);
      newState = setCheckBoxValue(newState, 'VoiceActorLiveActionExperience', action.voiceActorLiveActionExperience);
      newState = setCheckBoxValue(newState, 'VoiceActorAnimationExperience', action.voiceActorAnimationExperience);
      newState = setCheckBoxValue(newState, 'VoiceActorDubbingExperience', action.voiceActorDubbingExperience);
      newState = setCheckBoxValue(newState, 'VoiceActorAudiobooksExperience', action.voiceActorAudiobooksExperience);
      newState = setCheckBoxValue(newState, 'VoiceActorVoiceOverExperience', action.voiceActorVoiceOverExperience);
      newState = setCheckBoxValue(newState, 'VoiceActorRadioExperience', action.voiceActorRadioExperience);
      newState = setCheckBoxValue(newState, 'VoiceActorTheatreActorExperience', action.voiceActorTheatreActorExperience);
      newState = setCheckBoxValue(newState, 'VoiceActorMovieActorExperience', action.voiceActorMovieActorExperience);
      newState = setCheckBoxValue(newState, 'VoiceActorAudioDescriptionExperience', action.voiceActorAudioDescriptionExperience);
      newState = setCheckBoxValue(newState, 'BookerTheatricalExperience', action.bookerTheatricalExperience);
      newState = setCheckBoxValue(newState, 'BookerTVExperience', action.bookerTVExperience);
      newState = setCheckBoxValue(newState, 'BookerInteractiveExperience', action.bookerInteractiveExperience);
      newState = setCheckBoxValue(newState, 'SingerMaleVoiceGender', action.singerMaleVoiceGender);
      newState = setCheckBoxValue(newState, 'SingerFemaleVoiceGender', action.singerFemaleVoiceGender);
      newState = setCheckBoxValue(newState, 'SingerDubbingExperience', action.singerDubbingExperience);
      newState = setCheckBoxValue(newState, 'SingerStageExperience', action.singerStageExperience);
      newState = setCheckBoxValue(newState, 'SingerTheatreExperience', action.singerTheatreExperience);
      newState = setCheckBoxValue(newState, 'SingerTalentShowExperience', action.singerTalentShowExperience);
      newState = setCheckBoxValue(newState, 'SingerGenderNeutralVoice', action.singerGenderNeutralVoice);
      newState = setCheckBoxValue(newState, 'DirectorTheatricalExperience', action.directorTheatricalExperience);
      newState = setCheckBoxValue(newState, 'DirectorTVExperience', action.directorTVExperience);
      newState = setCheckBoxValue(newState, 'DirectorGamesExperience', action.directorGamesExperience);
      newState = setCheckBoxValue(newState, 'DirectorPromoOrCommercialsExperience', action.directorPromoOrCommercialsExperience);
      newState = setCheckBoxValue(newState, 'DirectorLiveActionExperience', action.directorLiveActionExperience);
      newState = setCheckBoxValue(newState, 'DirectorAnimationExperience', action.directorAnimationExperience);
      newState = setCheckBoxValue(newState, 'DirectorDubbingDirectorExperience', action.directorDubbingDirectorExperience);
      newState = setCheckBoxValue(newState, 'DirectorVoiceOverDirectorExperience', action.directorVoiceOverDirectorExperience);
      newState = setCheckBoxValue(newState, 'DirectorSongDirectorExperience', action.directorSongDirectorExperience);
      newState = setCheckBoxValue(newState, 'DirectorDubbingActorExperience', action.directorDubbingActorExperience);
      newState = setCheckBoxValue(newState, 'DirectorStageDirectorExperience', action.directorStageDirectorExperience);
      newState = setCheckBoxValue(newState, 'DirectorMovieDirectorExperience', action.directorMovieDirectorExperience);
      newState = setCheckBoxValue(newState, 'DirectorAudioDescriptionExperience', action.directorAudioDescriptionExperience);
      newState = setCheckBoxValue(newState, 'LyricistMusicalExperience', action.lyricistMusicalExperience);
      newState = setCheckBoxValue(newState, 'LyricistTheatreExperience', action.lyricistTheatreExperience);
      newState = setCheckBoxValue(newState, 'LyricistPromoOrCommercialsExperience', action.lyricistPromoCommercialsExperience);
      newState = setCheckBoxValue(newState, 'LyricistExperience', action.lyricistExperience);
      newState = setCheckBoxValue(newState, 'LyricistDubbingExperience', action.lyricistDubbingExperience);
      newState = setCheckBoxValue(newState, 'LyricistMusicianExperience', action.lyricistMusicianExperience);
      newState = setCheckBoxValue(newState, 'TranslatorTheatricalExperience', action.translatorTheatricalExperience);
      newState = setCheckBoxValue(newState, 'TranslatorTVExperience', action.translatorTVExperience);
      newState = setCheckBoxValue(newState, 'TranslatorGamesExperience', action.translatorGamesExperience);
      newState = setCheckBoxValue(newState, 'TranslatorPromoOrCommercialsExperience', action.translatorPromoOrCommercialsExperience);
      newState = setCheckBoxValue(newState, 'TranslatorLiveActionExperience', action.translatorLiveActionExperience);
      newState = setCheckBoxValue(newState, 'TranslatorAnimationExperience', action.translatorAnimationExperience);
      newState = setCheckBoxValue(newState, 'TranslatorSubtitlesExperience', action.translatorSubtitlesExperience);
      newState = setCheckBoxValue(newState, 'TranslatorDubbingExperience', action.translatorDubbingExperience);
      newState = setCheckBoxValue(newState, 'TranslatorVoiceOverExperience', action.translatorVoiceOverExperience);
      newState = setCheckBoxValue(newState, 'TranslatorGamingExperience', action.translatorGamingExperience);
      newState = setCheckBoxValue(newState, 'TranslatorAudioDescriptionExperience', action.translatorAudioDescriptionExperience);
      newState = setCheckBoxValue(newState, 'TranslatorHOHSDHCCExperience', action.translatorHOHSDHCCExperience);
      newState = setCheckBoxValue(newState, 'EditorDubbingExperience', action.editorDubbingExperience);
      newState = setCheckBoxValue(newState, 'EditorVoiceOverExperience', action.editorVoiceOverExperience);
      newState = setCheckBoxValue(newState, 'EditorSongsExperience', action.editorSongsExperience);
      newState = setCheckBoxValue(newState, 'EditorProToolsExperience', action.editorProToolsExperience);
      newState = setCheckBoxValue(newState, 'EditorDolby51Experience', action.editorDolby51Experience);
      newState = setCheckBoxValue(newState, 'EditorAtmosExperience', action.editorAtmosExperience);
      newState = setCheckBoxValue(newState, 'EditorFoleyExperience', action.editorFoleyExperience);
      newState = setCheckBoxValue(newState, 'EditorRecordingEditingExperience', action.editorRecordingEditingExperience);
      newState = setCheckBoxValue(newState, 'EditorDialogueEditingExperience', action.editorDialogueEditingExperience);
      newState = setCheckBoxValue(newState, 'EditorMusicAndEffectsExperience', action.editorMusicAndEffectsExperience);
      newState = setCheckBoxValue(newState, 'EditorMixEditingExperience', action.editorMixEditingExperience);
      newState = setCheckBoxValue(newState, 'EditorPreparingTakesExperience', action.editorPreparingTakesExperience);
      newState = setCheckBoxValue(newState, 'EditorAudioDescriptionExperience', action.editorAudioDescriptionExperience);
      newState = setCheckBoxValue(newState, 'AdaptorTheatricalExperience', action.adaptorTheatricalExperience);
      newState = setCheckBoxValue(newState, 'AdaptorTVExperience', action.adaptorTVExperience);
      newState = setCheckBoxValue(newState, 'AdaptorGamesExperience', action.adaptorGamesExperience);
      newState = setCheckBoxValue(newState, 'AdaptorPromoOrCommercialsExperience', action.adaptorPromoOrCommercialsExperience);
      newState = setCheckBoxValue(newState, 'AdaptorLiveActionExperience', action.adaptorLiveActionExperience);
      newState = setCheckBoxValue(newState, 'AdaptorAnimationExperience', action.adaptorAnimationExperience);
      newState = setCheckBoxValue(newState, 'AdaptorAdaptorExperience', action.adaptorAdaptorExperience);
      newState = setCheckBoxValue(newState, 'AdaptorDubbingDirectorExperience', action.adaptorDubbingDirectorExperience);
      newState = setCheckBoxValue(newState, 'AdaptorTranslatorExperience', action.adaptorTranslatorExperience);
      newState = setCheckBoxValue(newState, 'AdaptorVoiceActorExperience', action.adaptorVoiceActorExperience);
      newState = setCheckBoxValue(newState, 'AdaptorAudioDescriptionExperience', action.adaptorAudioDescriptionExperience);
      newState = setCheckBoxValue(newState, 'SoundEngineerDubbingExperience', action.soundEngineerDubbingExperience);
      newState = setCheckBoxValue(newState, 'SoundEngineerVoiceOverExperience', action.soundEngineerVoiceOverExperience);
      newState = setCheckBoxValue(newState, 'SoundEngineerSongsExperience', action.soundEngineerSongsExperience);
      newState = setCheckBoxValue(newState, 'SoundEngineerProToolsExperience', action.soundEngineerProToolsExperience);
      newState = setCheckBoxValue(newState, 'SoundEngineerDolby51Experience', action.soundEngineerDolby51Experience);
      newState = setCheckBoxValue(newState, 'SoundEngineerAtmosExperience', action.soundEngineerAtmosExperience);
      newState = setCheckBoxValue(newState, 'SoundEngineerFoleyExperience', action.soundEngineerFoleyExperience);
      newState = setCheckBoxValue(newState, 'SoundEngineerDialogueRecordingExperience', action.soundEngineerDialogueRecordingExperience);
      newState = setCheckBoxValue(newState, 'SoundEngineerSongRecordingExperience', action.soundEngineerSongRecordingExperience);
      newState = setCheckBoxValue(newState, 'SoundEngineerDialogueMixingExperience', action.soundEngineerDialogueMixingExperience);
      newState = setCheckBoxValue(newState, 'SoundEngineerSongMixingExperience', action.soundEngineerSongMixingExperience);
      newState = setCheckBoxValue(newState, 'SoundEngineerAudioDescriptionMixingExperience', action.soundEngineerAudioDescriptionMixingExperience);
      newState = setCheckBoxValue(newState, 'SingerGenderNeutralVoice', action.singerGenderNeutralVoice);
      newState = setCheckBoxValue(newState, 'VoiceActorGenderNeutralVoice', action.voiceActorGenderNeutralVoice);
      newState = setCheckBoxValue(newState, 'AdaptorDoNotUse', action.adaptorDoNotUse);
      newState = setCheckBoxValue(newState, 'BookerDoNotUse', action.bookerDoNotUse);
      newState = setCheckBoxValue(newState, 'DirectorDoNotUse', action.directorDoNotUse);
      newState = setCheckBoxValue(newState, 'EditorDoNotUse', action.editorDoNotUse);
      newState = setCheckBoxValue(newState, 'LyricistDoNotUse', action.lyricistDoNotUse);
      newState = setCheckBoxValue(newState, 'SingerDoNotUse', action.singerDoNotUse);
      newState = setCheckBoxValue(newState, 'SoundEngineerDoNotUse', action.soundEngineerDoNotUse);
      newState = setCheckBoxValue(newState, 'TranslatorDoNotUse', action.translatorDoNotUse);
      newState = setCheckBoxValue(newState, 'VoiceActorDoNotUse', action.voiceActorDoNotUse);





      return setCheckBoxValue(newState, 'DoNotUse', action.doNotUse);
    }

    case VALIDATE_VACANCY_CRITERIA_VOICEACTOR_FIELD: {
      return validateField(state, action);
    }

    case CLEAR_VACANCY_CRITERIA_VOICEACTOR_FIELDS: {
      return clearFields(state);
    }

    case SET_VOICE_TEST_CRITERIA_DROPDOWN_OPTIONS: {
      var newState = setFieldOptions(state, 'SkillLevel', action.skillLevels);
      newState = setFieldOptions(newState, 'City', action.cities);
      newState = setFieldOptions(newState, 'NativeLanguage', action.nativeLanguages);
      newState = setFieldOptions(newState, 'AdditionalLanguage', action.languages);
      newState = setFieldOptions(newState, 'AgeFrom', action.ageFromList);
      newState = setFieldOptions(newState, 'AgeTo', action.ageToList);
      newState = setFieldOptions(newState, 'CountryofLiving', action.country);
      newState = setFieldOptions(newState, 'Region', action.region);
      newState = setFieldOptions(newState, 'Ethnicity', action.ethnicity);
      newState = setFieldOptions(newState, 'Identity', action.identity);
      newState = setFieldOptions(newState, 'VoiceActorVoiceAge', action.voiceAgeRangeList);
      newState = setFieldOptions(newState, 'VoiceActorVoiceType', action.voiceTypeList);
      newState = setFieldOptions(newState, 'VoiceActorRemoteRecordingCapability', action.remoteRecordingListVoiceActor);
      newState = setFieldOptions(newState, 'VoiceActorStudios', action.voiceActorStudio);
      newState = setFieldOptions(newState, 'VoiceActorSchools', action.voiceActorSchool);
      newState = setFieldOptions(newState, 'VoiceActorLanguageAccent', action.languageAccentList);
      newState = setFieldOptions(newState, 'VoiceActorUnion', action.unionListVoiceActor);
      newState = setFieldOptions(newState, 'SkillType', action.skillTypes);
      newState = setFieldOptions(newState, 'Production', action.productionCast);
      newState = setFieldOptions(newState, 'Vacancy', action.vacancyCast);
      newState = setFieldOptions(newState, 'ExternalExperience', action.externalExperienceCast);
      newState = setFieldOptions(newState, 'BookerStudios', action.bookerStudio);
      newState = setFieldOptions(newState, 'SingerVoiceAge', action.voiceAgeRangeListSinger);
      newState = setFieldOptions(newState, 'SingerVocalRange', action.vocalRangeListSinger);
      newState = setFieldOptions(newState, 'SingerMusicNotesReadingLevel', action.readingMusicNoteListSinger);
      newState = setFieldOptions(newState, 'SingerStudios', action.singerStudio);
      newState = setFieldOptions(newState, 'SingerClient', action.singerClients);
      newState = setFieldOptions(newState, 'SingerSchools', action.singerSchool);
      newState = setFieldOptions(newState, 'SingerRemoteRecordingCapability', action.remoteRecordingListSinger);
      newState = setFieldOptions(newState, 'SingerUnion', action.unionListSinger);
      newState = setFieldOptions(newState, 'DirectorStudios', action.directorStudio);
      newState = setFieldOptions(newState, 'DirectorClient', action.directorClient);
      newState = setFieldOptions(newState, 'DirectorSchools', action.directorSchool);
      newState = setFieldOptions(newState, 'DirectorRemoteRecordingCapability', action.remoteRecordingDirector);
      newState = setFieldOptions(newState, 'DirectorAppAccessRevoked', action.directorAppAccess);
      newState = setFieldOptions(newState, 'LyricistNumberOfSongsWritten', action.numberOfSongsWrittenRangeListLyricist);
      newState = setFieldOptions(newState, 'LyricistUniversityDegree', action.universityDegreeListLyricist);
      newState = setFieldOptions(newState, 'LyricistStudios', action.lyricistStudio);
      newState = setFieldOptions(newState, 'LyricistClients', action.lyricistClient);
      newState = setFieldOptions(newState, 'LyricistRemoteRecordingCapability', action.remoteRecordingListLyricist);
      newState = setFieldOptions(newState, 'TranslatorNumberOfTranslations', action.numberOfTranslationsRangeListTranslator);
      newState = setFieldOptions(newState, 'TranslatorUniversityDegree', action.universityDegreeListTranslator);
      newState = setFieldOptions(newState, 'TranslatorStudios', action.translatorStudio);
      newState = setFieldOptions(newState, 'TranslatorClients', action.translatorClient);
      newState = setFieldOptions(newState, 'EditorStudios', action.editorStudio);
      newState = setFieldOptions(newState, 'EditorClients', action.editorClient);
      newState = setFieldOptions(newState, 'EditorSchools', action.editorSchool);
      newState = setFieldOptions(newState, 'EditorRemoteRecordingCapability', action.remoteRecordingEditor);
      newState = setFieldOptions(newState, 'AdaptorNumberOfAdaptionsRange', action.numberOfAdaptionsRangeListAdaptor);
      newState = setFieldOptions(newState, 'AdaptorUniversityDegree', action.universityDegreeListAdaptor);
      newState = setFieldOptions(newState, 'AdaptorStudios', action.adaptorStudio);
      newState = setFieldOptions(newState, 'AdaptorClients', action.adaptorClient);
      newState = setFieldOptions(newState, 'SoundEngineerStudios', action.soundEngineerStudio);
      newState = setFieldOptions(newState, 'SoundEngineerClients', action.soundEngineerClient);
      newState = setFieldOptions(newState, 'SoundEngineerSchools', action.soundEngineerSchool);
      newState = (newState, 'SoundEngineerRemoteRecordingCapability', action.remoteRecordingListSoundEngineer);






      return setFieldOptions(newState, 'AgeTo', action.ageToList);
    }

    case SET_VOICE_TEST_CRITERIA_CHECKBOX_VALUE: {
      var newState = setCheckBoxValue(state, 'KnownTalent', action.knownTalent);
      newState = setCheckBoxValue(newState, 'SkillVendorStatus', action.skillVendorStatus);
      newState = setCheckBoxValue(newState, 'VoiceActorLiveActionMaleVoiceGender', action.liveActionVoiceGenderMale);
      newState = setCheckBoxValue(newState, 'VoiceActorLiveActionFemaleVoiceGender', action.liveActionVoiceGenderFemale);
      newState = setCheckBoxValue(newState, 'VoiceActorTheatricalExperience', action.voiceActorTheatricalExperience);
      newState = setCheckBoxValue(newState, 'VoiceActorTVExperience', action.voiceActorTVExperience);
      newState = setCheckBoxValue(newState, 'VoiceActorGamesExperience', action.voiceActorVideoGamesExperience);
      newState = setCheckBoxValue(newState, 'VoiceActorPromoOrCommercialsExperience', action.voiceActorPromoOrCommercialsExperience);
      newState = setCheckBoxValue(newState, 'VoiceActorAnimationMaleVoiceGender', action.voiceActorAnimationMaleVoiceGender);
      newState = setCheckBoxValue(newState, 'VoiceActorAnimationFemaleVoiceGender', action.voiceActorAnimationFemaleVoiceGender);
      newState = setCheckBoxValue(newState, 'VoiceActorLiveActionExperience', action.voiceActorLiveActionExperience);
      newState = setCheckBoxValue(newState, 'VoiceActorAnimationExperience', action.voiceActorAnimationExperience);
      newState = setCheckBoxValue(newState, 'VoiceActorDubbingExperience', action.voiceActorDubbingExperience);
      newState = setCheckBoxValue(newState, 'VoiceActorAudiobooksExperience', action.voiceActorAudiobooksExperience);
      newState = setCheckBoxValue(newState, 'VoiceActorVoiceOverExperience', action.voiceActorVoiceOverExperience);
      newState = setCheckBoxValue(newState, 'VoiceActorRadioExperience', action.voiceActorRadioExperience);
      newState = setCheckBoxValue(newState, 'VoiceActorTheatreActorExperience', action.voiceActorTheatreActorExperience);
      newState = setCheckBoxValue(newState, 'VoiceActorMovieActorExperience', action.voiceActorMovieActorExperience);
      newState = setCheckBoxValue(newState, 'VoiceActorAudioDescriptionExperience', action.voiceActorAudioDescriptionExperience);
      newState = setCheckBoxValue(newState, 'BookerTheatricalExperience', action.bookerTheatricalExperience);
      newState = setCheckBoxValue(newState, 'BookerTVExperience', action.bookerTVExperience);
      newState = setCheckBoxValue(newState, 'BookerInteractiveExperience', action.bookerInteractiveExperience);
      newState = setCheckBoxValue(newState, 'SingerMaleVoiceGender', action.singerMaleVoiceGender);
      newState = setCheckBoxValue(newState, 'SingerFemaleVoiceGender', action.singerFemaleVoiceGender);
      newState = setCheckBoxValue(newState, 'SingerDubbingExperience', action.singerDubbingExperience);
      newState = setCheckBoxValue(newState, 'SingerStageExperience', action.singerStageExperience);
      newState = setCheckBoxValue(newState, 'SingerTheatreExperience', action.singerTheatreExperience);
      newState = setCheckBoxValue(newState, 'SingerTalentShowExperience', action.singerTalentShowExperience);
      newState = setCheckBoxValue(newState, 'SingerGenderNeutralVoice', action.singerGenderNeutralVoice);
      newState = setCheckBoxValue(newState, 'DirectorTheatricalExperience', action.directorTheatricalExperience);
      newState = setCheckBoxValue(newState, 'DirectorTVExperience', action.directorTVExperience);
      newState = setCheckBoxValue(newState, 'DirectorGamesExperience', action.directorGamesExperience);
      newState = setCheckBoxValue(newState, 'DirectorPromoOrCommercialsExperience', action.directorPromoOrCommercialsExperience);
      newState = setCheckBoxValue(newState, 'DirectorLiveActionExperience', action.directorLiveActionExperience);
      newState = setCheckBoxValue(newState, 'DirectorAnimationExperience', action.directorAnimationExperience);
      newState = setCheckBoxValue(newState, 'DirectorDubbingDirectorExperience', action.directorDubbingDirectorExperience);
      newState = setCheckBoxValue(newState, 'DirectorVoiceOverDirectorExperience', action.directorVoiceOverDirectorExperience);
      newState = setCheckBoxValue(newState, 'DirectorSongDirectorExperience', action.directorSongDirectorExperience);
      newState = setCheckBoxValue(newState, 'DirectorDubbingActorExperience', action.directorDubbingActorExperience);
      newState = setCheckBoxValue(newState, 'DirectorStageDirectorExperience', action.directorStageDirectorExperience);
      newState = setCheckBoxValue(newState, 'DirectorMovieDirectorExperience', action.directorMovieDirectorExperience);
      newState = setCheckBoxValue(newState, 'DirectorAudioDescriptionExperience', action.directorAudioDescriptionExperience);
      newState = setCheckBoxValue(newState, 'LyricistMusicalExperience', action.lyricistMusicalExperience);
      newState = setCheckBoxValue(newState, 'LyricistTheatreExperience', action.lyricistTheatreExperience);
      newState = setCheckBoxValue(newState, 'LyricistPromoOrCommercialsExperience', action.lyricistPromoCommercialsExperience);
      newState = setCheckBoxValue(newState, 'LyricistExperience', action.lyricistExperience);
      newState = setCheckBoxValue(newState, 'LyricistDubbingExperience', action.lyricistDubbingExperience);
      newState = setCheckBoxValue(newState, 'LyricistMusicianExperience', action.lyricistMusicianExperience);
      newState = setCheckBoxValue(newState, 'TranslatorTheatricalExperience', action.translatorTheatricalExperience);
      newState = setCheckBoxValue(newState, 'TranslatorTVExperience', action.translatorTVExperience);
      newState = setCheckBoxValue(newState, 'TranslatorGamesExperience', action.translatorGamesExperience);
      newState = setCheckBoxValue(newState, 'TranslatorPromoOrCommercialsExperience', action.translatorPromoOrCommercialsExperience);
      newState = setCheckBoxValue(newState, 'TranslatorLiveActionExperience', action.translatorLiveActionExperience);
      newState = setCheckBoxValue(newState, 'TranslatorAnimationExperience', action.translatorAnimationExperience);
      newState = setCheckBoxValue(newState, 'TranslatorSubtitlesExperience', action.translatorSubtitlesExperience);
      newState = setCheckBoxValue(newState, 'TranslatorDubbingExperience', action.translatorDubbingExperience);
      newState = setCheckBoxValue(newState, 'TranslatorVoiceOverExperience', action.translatorVoiceOverExperience);
      newState = setCheckBoxValue(newState, 'TranslatorGamingExperience', action.translatorGamingExperience);
      newState = setCheckBoxValue(newState, 'TranslatorAudioDescriptionExperience', action.translatorAudioDescriptionExperience);
      newState = setCheckBoxValue(newState, 'TranslatorHOHSDHCCExperience', action.translatorHOHSDHCCExperience);
      newState = setCheckBoxValue(newState, 'EditorDubbingExperience', action.editorDubbingExperience);
      newState = setCheckBoxValue(newState, 'EditorVoiceOverExperience', action.editorVoiceOverExperience);
      newState = setCheckBoxValue(newState, 'EditorSongsExperience', action.editorSongsExperience);
      newState = setCheckBoxValue(newState, 'EditorProToolsExperience', action.editorProToolsExperience);
      newState = setCheckBoxValue(newState, 'EditorDolby51Experience', action.editorDolby51Experience);
      newState = setCheckBoxValue(newState, 'EditorAtmosExperience', action.editorAtmosExperience);
      newState = setCheckBoxValue(newState, 'EditorFoleyExperience', action.editorFoleyExperience);
      newState = setCheckBoxValue(newState, 'EditorRecordingEditingExperience', action.editorRecordingEditingExperience);
      newState = setCheckBoxValue(newState, 'EditorDialogueEditingExperience', action.editorDialogueEditingExperience);
      newState = setCheckBoxValue(newState, 'EditorMusicAndEffectsExperience', action.editorMusicAndEffectsExperience);
      newState = setCheckBoxValue(newState, 'EditorMixEditingExperience', action.editorMixEditingExperience);
      newState = setCheckBoxValue(newState, 'EditorPreparingTakesExperience', action.editorPreparingTakesExperience);
      newState = setCheckBoxValue(newState, 'EditorAudioDescriptionExperience', action.editorAudioDescriptionExperience);
      newState = setCheckBoxValue(newState, 'AdaptorTheatricalExperience', action.adaptorTheatricalExperience);
      newState = setCheckBoxValue(newState, 'AdaptorTVExperience', action.adaptorTVExperience);
      newState = setCheckBoxValue(newState, 'AdaptorGamesExperience', action.adaptorGamesExperience);
      newState = setCheckBoxValue(newState, 'AdaptorPromoOrCommercialsExperience', action.adaptorPromoOrCommercialsExperience);
      newState = setCheckBoxValue(newState, 'AdaptorLiveActionExperience', action.adaptorLiveActionExperience);
      newState = setCheckBoxValue(newState, 'AdaptorAnimationExperience', action.adaptorAnimationExperience);
      newState = setCheckBoxValue(newState, 'AdaptorAdaptorExperience', action.adaptorAdaptorExperience);
      newState = setCheckBoxValue(newState, 'AdaptorDubbingDirectorExperience', action.adaptorDubbingDirectorExperience);
      newState = setCheckBoxValue(newState, 'AdaptorTranslatorExperience', action.adaptorTranslatorExperience);
      newState = setCheckBoxValue(newState, 'AdaptorVoiceActorExperience', action.adaptorVoiceActorExperience);
      newState = setCheckBoxValue(newState, 'AdaptorAudioDescriptionExperience', action.adaptorAudioDescriptionExperience);
      newState = setCheckBoxValue(newState, 'SoundEngineerDubbingExperience', action.soundEngineerDubbingExperience);
      newState = setCheckBoxValue(newState, 'SoundEngineerVoiceOverExperience', action.soundEngineerVoiceOverExperience);
      newState = setCheckBoxValue(newState, 'SoundEngineerSongsExperience', action.soundEngineerSongsExperience);
      newState = setCheckBoxValue(newState, 'SoundEngineerProToolsExperience', action.soundEngineerProToolsExperience);
      newState = setCheckBoxValue(newState, 'SoundEngineerDolby51Experience', action.soundEngineerDolby51Experience);
      newState = setCheckBoxValue(newState, 'SoundEngineerAtmosExperience', action.soundEngineerAtmosExperience);
      newState = setCheckBoxValue(newState, 'SoundEngineerFoleyExperience', action.soundEngineerFoleyExperience);
      newState = setCheckBoxValue(newState, 'SoundEngineerDialogueRecordingExperience', action.soundEngineerDialogueRecordingExperience);
      newState = setCheckBoxValue(newState, 'SoundEngineerSongRecordingExperience', action.soundEngineerSongRecordingExperience);
      newState = setCheckBoxValue(newState, 'SoundEngineerDialogueMixingExperience', action.soundEngineerDialogueMixingExperience);
      newState = setCheckBoxValue(newState, 'SoundEngineerSongMixingExperience', action.soundEngineerSongMixingExperience);
      newState = setCheckBoxValue(newState, 'SoundEngineerAudioDescriptionMixingExperience', action.soundEngineerAudioDescriptionMixingExperience);
      newState = setCheckBoxValue(newState, 'SingerGenderNeutralVoice', action.singerGenderNeutralVoice);
      newState = setCheckBoxValue(newState, 'VoiceActorGenderNeutralVoice', action.voiceActorGenderNeutralVoice);




      return setCheckBoxValue(newState, 'DoNotUse', action.doNotUse);
    }

    case VALIDATE_VOICE_TEST_CRITERIA_VOICEACTOR_FIELD: {
      return validateField(state, action);
    }

    case CLEAR_VOICE_TEST_CRITERIA_VOICEACTOR_FIELDS: {
      return clearFields(state);
    }

    default:
      return state
  }
}
